import "firebase/firestore";

import app from "./app";

const db = app.firestore();

if (import.meta.env.VITE_USE_EMULATOR) {
	db.useEmulator("localhost", 8080);
}

export default db;
